// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ClientSelectModal.css */

.csm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.csm-modal {
  width: 420px;
  max-width: calc(100vw - 24px);
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  padding: 16px;
}

/* header centered title */
.csm-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.csm-title {
  font-size: 18px;
  font-weight: 700;
  text-align: center;
}

.csm-close {
  position: absolute;
  right: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.csm-close:hover {
  background: rgba(0, 0, 0, 0.06);
}

.csm-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}

.csm-tab {
  padding-left: 10px;
  flex: 1 1;
  border: 1px solid #d7d7d7;
  background: #fff;
  height: 40px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* green accent for active tab */
.csm-tab.active {

  border-color: rgba(29, 135, 82, 1);
  color: rgba(29, 135, 82, 1);
}

.csm-search {
  margin-bottom: 10px;
}

.csm-searchInput {
  width: 100%;
  height: 42px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 0 12px;
  outline: none;
  font-size: 14px;
}

.csm-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 420px;
  overflow: auto;
  padding-right: 2px;
  margin-bottom: 12px;
}

/* Center words inside buttons */
.csm-item {
  height: 44px;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  background: #fff;
  cursor: pointer;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;
  transition: all 0.2s ease;
}

/* green hover */
.csm-item:hover {
  border-color: rgba(29, 135, 82, 0.6);
  background: rgba(29, 135, 82, 0.05);
}

/* green selected */
.csm-item.selected {
  border-color: rgba(29, 135, 82, 1);
  background: rgba(29, 135, 82, 0.08);
  color: rgba(29, 135, 82, 1);
  box-shadow: 0 0 0 2px rgba(29, 135, 82, 0.15);
}

.csm-empty {
  padding: 14px;
  text-align: center;
  opacity: 0.7;
}

.csm-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
}

.csm-pageBtn,
.csm-pageNum {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: #fff;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;

  display: flex;
  align-items: center;
  justify-content: center;
}

/* green active page */
.csm-pageNum.active {
  border-color: rgba(29, 135, 82, 1);
  color: rgba(29, 135, 82, 1);
  background: rgba(29, 135, 82, 0.06);
}

.csm-pageBtn:hover,
.csm-pageNum:hover {
  border-color: rgba(29, 135, 82, 0.6);
  background: rgba(29, 135, 82, 0.05);
}

.csm-pageBtn:disabled {
  opacity: 0.45;
  cursor: default;
}

/* green confirm button */
.csm-confirm {
  width: 100%;
  height: 48px;
  text-align: center;
  border: none;
  border-radius: 12px;
  background: rgba(29, 135, 82, 1);
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
}

.csm-confirm:hover {
  background: rgba(24, 115, 70, 1);
}

.csm-confirm:disabled {
  background: rgba(29, 135, 82, 0.4);
  cursor: default;
}

.csm-new {
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 12px;
}

.csm-newLabel {
  font-weight: 700;
  margin-bottom: 8px;
}

.csm-newInput {
  width: 100%;
  height: 42px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 0 12px;
  outline: none;
  font-size: 14px;
}

.csm-newHint {
  margin-top: 8px;
  font-size: 12px;
  opacity: 0.65;
}

.csm-newGrid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.csm-newSelect {
  width: 100%;
  height: 42px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 0 12px;
  outline: none;
  font-size: 14px;
  background: #fff;
}

.csm-error {
  margin-top: 10px;
  font-size: 13px;
  color: #d32f2f;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SalesPages/ClientSelectModal.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;;EAEE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;;EAEhB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA,mBAAmB;AACnB;EACE,kCAAkC;EAClC,mCAAmC;EACnC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;;EAEzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;;EAEE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* ClientSelectModal.css */\n\n.csm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.csm-modal {\n  width: 420px;\n  max-width: calc(100vw - 24px);\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\n  padding: 16px;\n}\n\n/* header centered title */\n.csm-header {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n}\n\n.csm-title {\n  font-size: 18px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.csm-close {\n  position: absolute;\n  right: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.csm-close:hover {\n  background: rgba(0, 0, 0, 0.06);\n}\n\n.csm-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.csm-tab {\n  padding-left: 10px;\n  flex: 1;\n  border: 1px solid #d7d7d7;\n  background: #fff;\n  height: 40px;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n/* green accent for active tab */\n.csm-tab.active {\n\n  border-color: rgba(29, 135, 82, 1);\n  color: rgba(29, 135, 82, 1);\n}\n\n.csm-search {\n  margin-bottom: 10px;\n}\n\n.csm-searchInput {\n  width: 100%;\n  height: 42px;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  padding: 0 12px;\n  outline: none;\n  font-size: 14px;\n}\n\n.csm-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 420px;\n  overflow: auto;\n  padding-right: 2px;\n  margin-bottom: 12px;\n}\n\n/* Center words inside buttons */\n.csm-item {\n  height: 44px;\n  border-radius: 12px;\n  border: 1px solid #e0e0e0;\n  background: #fff;\n  cursor: pointer;\n  font-weight: 600;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  text-align: center;\n  transition: all 0.2s ease;\n}\n\n/* green hover */\n.csm-item:hover {\n  border-color: rgba(29, 135, 82, 0.6);\n  background: rgba(29, 135, 82, 0.05);\n}\n\n/* green selected */\n.csm-item.selected {\n  border-color: rgba(29, 135, 82, 1);\n  background: rgba(29, 135, 82, 0.08);\n  color: rgba(29, 135, 82, 1);\n  box-shadow: 0 0 0 2px rgba(29, 135, 82, 0.15);\n}\n\n.csm-empty {\n  padding: 14px;\n  text-align: center;\n  opacity: 0.7;\n}\n\n.csm-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.csm-pageBtn,\n.csm-pageNum {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  background: #fff;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.2s ease;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* green active page */\n.csm-pageNum.active {\n  border-color: rgba(29, 135, 82, 1);\n  color: rgba(29, 135, 82, 1);\n  background: rgba(29, 135, 82, 0.06);\n}\n\n.csm-pageBtn:hover,\n.csm-pageNum:hover {\n  border-color: rgba(29, 135, 82, 0.6);\n  background: rgba(29, 135, 82, 0.05);\n}\n\n.csm-pageBtn:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n/* green confirm button */\n.csm-confirm {\n  width: 100%;\n  height: 48px;\n  text-align: center;\n  border: none;\n  border-radius: 12px;\n  background: rgba(29, 135, 82, 1);\n  color: #fff;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.csm-confirm:hover {\n  background: rgba(24, 115, 70, 1);\n}\n\n.csm-confirm:disabled {\n  background: rgba(29, 135, 82, 0.4);\n  cursor: default;\n}\n\n.csm-new {\n  border: 1px solid #eee;\n  border-radius: 10px;\n  padding: 12px;\n  margin-bottom: 12px;\n}\n\n.csm-newLabel {\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.csm-newInput {\n  width: 100%;\n  height: 42px;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  padding: 0 12px;\n  outline: none;\n  font-size: 14px;\n}\n\n.csm-newHint {\n  margin-top: 8px;\n  font-size: 12px;\n  opacity: 0.65;\n}\n\n.csm-newGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n}\n\n.csm-newSelect {\n  width: 100%;\n  height: 42px;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  padding: 0 12px;\n  outline: none;\n  font-size: 14px;\n  background: #fff;\n}\n\n.csm-error {\n  margin-top: 10px;\n  font-size: 13px;\n  color: #d32f2f;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
